var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "i-table" },
    [
      _c("Table", {
        key: Math.random(),
        ref: "table",
        attrs: {
          stripe: _vm.stripe,
          border: _vm.border,
          height: _vm.height,
          "row-class-name": _vm.rowClassName,
          loading: _vm.loading,
          columns: _vm.columns,
          data: _vm.data,
          "span-method": _vm.spanMethod,
        },
        on: {
          "on-row-click": _vm.handleRowClick,
          "on-selection-change": _vm.handleSelectionChange,
        },
      }),
      _vm._t("default"),
      _vm.total
        ? _c("Page", {
            staticClass: "page",
            attrs: {
              "show-elevator": "",
              "show-total": "",
              size: _vm.size,
              "show-sizer": "",
              placement: "top",
              total: _vm.total,
              current: _vm.current,
              "page-size": _vm.pageSize,
              "page-size-opts": _vm.pageSizeOpts,
            },
            on: {
              "on-change": _vm.handlePageChange,
              "on-page-size-change": _vm.handlePageSizeChange,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }